import React from 'react';
import { AssignmentRow } from '../../../types/assignment/AssignmentGetResponse';
import DeleteButton from '../../../components/button/DeleteButton';

type Props = {
  item: AssignmentRow;
  onDelete: (item: AssignmentRow) => void;
};

const RenderAssignmentRow: React.FC<Props> = ({ item, onDelete }) => {
  return (
    <>
      <td>{item.employeeCode}</td>
      <td>{item.name}</td>
      <td className="text-center align-middle">
        <DeleteButton onClick={() => onDelete(item)} />
      </td>
    </>
  );
};

export default RenderAssignmentRow;
